export default __webpack_public_path__ + "static/CbCoFooter-98f11073e8a11b2b6dce26e39203656e.svg";